<template>
  <VMenu
    ref="wrapper"
    v-model="modal"
    :disabled="$attrs.readonly"
    :return-value.sync="date"
    v-bind="{
      ...{
        closeOnContentClick : false,
        transition: 'scale-transition',
        offsetY: true,
        maxWidth: '290px',
        minWidth: '290px'
      },
      ...wrapperProps
    }"
  >
    <template #activator="{ on, attrs }">
      <VTextField
        :value="formatedDate"
        :label="label"
        v-bind="{
          ...attrs,
          clearable: true,
          appendIcon: 'mdi-calendar',
          readonly: true,
          ...$attrs
        }"
        v-on="on"
        @click:clear="clear"
        @click:append="modal = true"
      />
    </template>
    <VDatePicker
      v-model="date"
      v-bind="{
        ...{
          fullWidth: true,
          scrollable: true,
          locale: convertLocale(currentLocale, 'bcp47'),
        },
        ...datePickerProps
      }"
    >
      <VBtn
        v-if="cancelBtn"
        text
        color="primary"
        @click="modal = false"
      >
        {{ $t('common.cancel') }}
      </VBtn>
      <VBtn
        v-if="clearBtn"
        text
        color="primary"
        @click="clear"
      >
        {{ $t('common.clear') }}
      </VBtn>
      <VSpacer />

      <VBtn
        v-if="okBtn"
        color="primary"
        @click="$refs.wrapper.save(date)"
      >
        {{ $t('common.ok') }}
      </VBtn>
    </VDatePicker>
  </VMenu>
</template>

<script>
import moment from 'moment'
export default {
  components: {
  },
  props: {
    value: {
      validator: prop => typeof prop === 'string' || prop === null || prop === undefined,
      default: undefined
    },
    label: {
      type: String,
      default: ''
    },
    wrapperProps: {
      type: Object,
      default: () => {}
    },
    datePickerProps: {
      type: Object,
      default: () => {}
    },
    customTextFormat: {
      type: Function,
      default: (date,moment) => {
        return moment(date).format('YYYY/MM/DD')
      }
    },
    clearValue: {
      type: String,
      default: undefined
    },
    cancelBtn: {
      type: Boolean,
      default: true
    },
    clearBtn: {
      type: Boolean,
      default: true
    },
    okBtn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      modal: false,
      date: null,
      wrapperPropsMapping: {
        VDialog: {
          persistent: true,
          width: '300px'
        }
      }
    }
  },
  computed: {
    formatedDate () {
      if (this.date === null || this.date === undefined || this.date === '') return ''
      if (moment(this.date).isValid()) return this.customTextFormat(this.date,moment)
      else return ''
    }
  },
  watch: {
    value: {
      handler (val) {
        this.date = val
      },
      immediate: true
    },
    date (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  },
  methods: {
    clear () {
      this.date = this.clearValue
    }
  }
}
</script>
